import { ErrorString, InvalidOperationException } from "../../shared/index.js";
export const average = async (source, selector) => {
    let value = 0;
    let count = 0;
    if (selector) {
        for await (const item of source) {
            value = value + selector(item);
            count = count + 1;
        }
    }
    else {
        for await (const item of source) {
            value = value + item;
            count = count + 1;
        }
    }
    if (count === 0) {
        throw new InvalidOperationException(ErrorString.NoElements);
    }
    return value / count;
};
